import type { ReactNode } from 'react'

import { StreamingMarkdownContent } from './streaming-markdown-content.molecule'

export interface ChatDelegationReportProps {
  content: string
  isStreaming?: boolean
}

export const ChatDelegationReport: React.FC<ChatDelegationReportProps> = ({
  content,
  isStreaming = false,
}): ReactNode => (
  <div className="chat-delegation-report mt-2 max-h-96 overflow-auto rounded-md border bg-muted/30 p-3 text-sm leading-relaxed text-foreground">
    <StreamingMarkdownContent content={content} variant="assistant" isStreaming={isStreaming} />
  </div>
)
